import { Controller } from "@hotwired/stimulus";
import Tabulator from "../lib/tabulator";

export default class extends Controller {
  connect() {
    const rows = this.parseRows();
    const columns = this.buildColumns();

    this.tabulator = new Tabulator(this.element, {
      data: rows,
      columns: columns,
      layout: "fitData",
    });
  }

  disconnect() {
    this.tabulator?.destroy();
  }

  parseRows() {
    return Array.from(this.element.querySelectorAll("tbody tr")).map((row) => {
      const obj = {};
      Array.from(row.querySelectorAll("td")).forEach((td, i) => {
        obj[`c${i}`] = td.innerHTML;
      });
      return obj;
    });
  }

  buildColumns() {
    return Array.from(this.element.querySelectorAll("thead th")).map((th, i) => {
      const col = {
        title: th.textContent.trim(),
        field: `c${i}`,
        formatter: "html",
        hozAlign: th.classList.contains("text-end") ? "right" : "left",
        headerHozAlign: th.classList.contains("text-end") ? "right" : "left",
      };

      if (i === 0) {
        col.headerSort = false;
      }

      if (i === 1) {
        col.headerFilter = "list";
        col.headerFilterParams = {
          values: { "": "All", budget: "Budget", tournament: "Tournament" },
          clearable: true,
        };
      }

      return col;
    });
  }
}
